import React, { useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { CustomisationOptionGroup } from '../types/customisation';
import { CartContext, CartItem } from '../context/cart-context';
import { CustomButton } from '../elements/button';
import { optionSymbol } from '../constants/orderStatusTextConstants';
import { BUTTONS } from '../constants/button-labels';
import { useTranslation } from 'react-i18next';

interface RepeatCustomizationDialogProps {
  open: boolean;
  item: CartItem | null;
  cartItemID: string;
  customisations?: CustomisationOptionGroup[];
  onClose: () => void;
  onChoose: (item: CartItem | null) => void;
}

const RepeatCustomizationDialog: React.FC<RepeatCustomizationDialogProps> = ({
  open,
  cartItemID = '',
  item,
  customisations = [],
  onClose,
  onChoose,
}) => {
  const addOptions =
    customisations?.map((c) => `${optionSymbol[c.type]}${c.name}`) || [];

  const { addToCart } = useContext(CartContext);
  const { t } = useTranslation(['patron_portal', 'common']);

  async function repeatItemWithCustomisations(
    cartItemID: string,
    cartItem: CartItem,
    count: number,
  ) {
    addToCart(cartItemID, cartItem, count);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '65%', sm: '400px' },
          height: 'auto',
          maxWidth: '70vw',
          borderRadius: '12px',
          padding: { xs: '20px', sm: '20px 32px' },
          margin: 0,
        },
      }}
    >
      <DialogTitle variant="repeatCustomizationTitle">
        {t('patron_portal.order.msgRepeatLastUsedCustomization', {
          ns: 'patron_portal',
        })}
      </DialogTitle>

      <DialogContent sx={{ paddingBottom: '20px' }}>
        {addOptions.length > 0 && (
          <Typography variant="addOptionsText">
            <Typography variant="labelBold" component="span">
              {t('patron_portal.order.msgQuantity', {
                ns: 'patron_portal',
              })}
            </Typography>{' '}
            {addOptions.join(', ')}
          </Typography>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 4,
          padding: '0 8px 12px 8px',
          marginTop: '8px',
          justifyContent: 'center !important',
          alignItems: 'center',
        }}
      >
        <CustomButton
          title={BUTTONS.CHOOSE_OPTIONS}
          onClick={() => {
            onClose();
            onChoose(item);
          }}
          style={{
            minWidth: 'auto !important',
            width: '80%',
            height: '42px',
            '@media (min-width: 600px)': {
              minWidth: 'auto !important',
              width: '140px',
            },
          }}
        />

        <CustomButton
          title={BUTTONS.REPEAT_LAST}
          onClick={() => {
            if (!item) {
              onClose();
              return;
            }
            repeatItemWithCustomisations(cartItemID, item, 1);
            onClose();
          }}
          style={{
            minWidth: 'auto !important',
            width: '80%',
            height: '42px',
            '@media (min-width: 600px)': {
              minWidth: 'auto !important',
              width: '140px',
            },
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default RepeatCustomizationDialog;
